import { render, staticRenderFns } from "./ButtonBehaviour.vue?vue&type=template&id=7f5fe3be&"
import script from "./ButtonBehaviour.vue?vue&type=script&lang=ts&"
export * from "./ButtonBehaviour.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonBehaviour.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports